import { z } from 'zod/v4';

export const contactInfoSchema = z.object({
  numberOfWeeksToSaveData: z.number(),
  contactName: z.string().nullable(),
  contactEmail: z.string().nullable(),
  contactPhone: z.string().nullable(),
});

export type ContactInfo = z.infer<typeof contactInfoSchema>;
